<template>
  <ModalButton :href="subscriptionPage" text="Get credits" />
</template>

<script setup lang="ts">
import ModalButton from '@/components/Buttons/ModalButton.vue'
const subscriptionPage = import.meta.env.VITE_WEBSITE_URL + 'subscription/?type=user#plan-wrapper'
</script>
